<template>
    <page class="home-page">
        <zui-header>
            <logo type="xiaoyanyun" href="/"></logo>
            <h4 class="zui-logo-text">
                |&nbsp;&nbsp;国潮国色 让爱美丽
                <br/>|&nbsp;&nbsp;让家健康 让社会更美好
            </h4>
            <el-dropdown class="zui-rightcol" @command="handleCommand" trigger="click">
                <span class="el-dropdown-link">
                  网站导航<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <template v-for="(zbtn,zi) in headBtn">
                        <el-dropdown-item :command="zbtn.key" :key="zi">{{zbtn.text}}</el-dropdown-item>
                    </template>
                </el-dropdown-menu>
            </el-dropdown>
            <template v-for="(zbtn,zi) in headBtn">
                <zui-button @click="onButtonClick(zbtn.key)" :key="zi" :class="activeFlag(zbtn.key)?'active':''">{{zbtn.text}}</zui-button>
            </template>
        </zui-header>

        <div id="wrapper2" class="pcWrapper">
            <!--focus start-->
            <div id="FocusBG" class="pcFocusBG joinFocusBG">
                <img src="../assets/img/join/an_bg.jpg" class="inside_top_bg">
            </div>

            <!--focus end-->
            <!--body start-->
            <div id="body">
                <!--inner start -->
                <div class="inner join">
                    <!--right start-->
                    <div class="right">
                        <div class="PosLeft">品牌加盟</div>
                        <!--main start-->
                        <div class="main">

                            <!--content start-->
                            <div class="content">
                                <div class="maincontent clearfix">
                                    <nav>
                                        <p style="text-align:center;">
                                            <img src="../assets/img/join/20220822143550235023.jpg" alt=""><br>
                                            <img src="../assets/img/join/20220822143519611961.jpg" alt=""><br>
                                            <img src="../assets/img/join/20220617115862306230.jpg" alt="">
                                        </p>
                                        <p style="text-align:center;">
                                            <img src="../assets/img/join/20220617115843474347.jpg" alt=""><br>
<!--                                            <img src="/images/image/20221022113687698769.jpg" alt="">-->
                                        </p>
                                        <p>
                                            为了能让所有的加盟商都能获得成功，我们将为每一位有意加盟经营珂立诺艺术涂料的经销商提出具体的要求，只要您具备了我们的条件，您将可以成为我们的战略合作伙伴，我们将为您提供一个创造财富的广阔平台。&nbsp;
                                        </p>
                                        <br>
                                        01、具有进取精神及创业精神，有坚定成功的信心。<br>
                                        02、具有一定经营管理、组织能力，对涂料市场有充分的认识。<br>
                                        03、能够严格遵守专卖店经营章程原则与职业道德。<br>
                                        04、具备良好的商业信誉，无欺诈污点。<br>
                                        05、拥有进行市场推广与品牌建设的必要资金。<br>
                                        06、拥有品牌建设所需的投资理念和风险意识。<br>
                                        07、在行业中拥有一定的客户群体与合作伙伴等人脉资源。<br>
                                        08、能够配合珂立诺艺术涂料的宣传推广，有合理的计划，有较强的执行力。<br>
                                        09、拥有共同投入、共担风险、利益共享的合作意识。<br>
                                        10、能够在经营理念、运作方式、管理制度等方面与公司达成共识并服从公司的管理。&nbsp;<br>
                                        11、有良好的经营管理理念和终端运作能力。<br>
                                        12、必须严格执行按公司标准方案进行专卖店装修，且专卖珂立诺艺术涂料。<br>
                                        &nbsp;<br>
                                        如果您具备了上述条件，并能认可我们的企业文化和市场运作模式，我们随时欢迎您的加盟!<br>
                                        <div class="clearfix"></div>
                                    </nav>
                                </div>


                            </div>
                            <!--content end-->

                        </div>
                        <!--main end-->
                    </div>
                    <!--right end-->
                    <div class="clearfix"></div>
                </div>
                <!--inner end-->
            </div>
            <!--body end-->
            <div class="HeightTab clearfix"></div>
        </div>


        <div id="wrapper">
            <!--focus start-->
            <div id="FocusBG">
                <img src="../assets/img/join/man_bg.jpg" class="inside_top_bg">

                <div class="inside_top">
                    <div class="container">
                        <div class="in_title">
                            <h2>招商加盟</h2>
                            <h1>join</h1>
                            <div class="ico"></div>
                        </div>
                    </div>
                </div>

            </div>


            <!--focus end-->
            <!--body start-->
            <div id="body">
                <!--inner start -->
                <div class="inner">
                    <!--right start-->
                    <div class="right">
                        <div class="Position"><span>你的位置：<a href="/">首页</a> &gt; <a href="/M/join/">招商加盟</a> &gt; <a href="/M/join/conditions/">加盟条件</a></span></div>
                        <div class="HeightTab clearfix"></div>
                        <!--main start-->
                        <div class="main">

                            <!--content start-->
                            <div class="content">
                                <div class="maincontent clearfix">
                                    <nav>
                                        <p style="text-align:center;">
                                            <img src="../assets/img/join/20220822143550235023.jpg" alt=""><br>
                                            <img src="../assets/img/join/20220822143519611961.jpg" alt=""><br>
                                            <img src="../assets/img/join/20220617115862306230.jpg" alt="">
                                        </p>
                                        <p style="text-align:center;">
                                            <img src="../assets/img/join/20220617115843474347.jpg" alt=""><br>
<!--                                            <img src="/images/image/20221022113687698769.jpg" alt="">-->
                                        </p>
                                        <p>
                                            为了能让所有的加盟商都能获得成功，我们将为每一位有意加盟经营珂立诺艺术涂料的经销商提出具体的要求，只要您具备了我们的条件，您将可以成为我们的战略合作伙伴，我们将为您提供一个创造财富的广阔平台。&nbsp;
                                        </p>
                                        <br>
                                        01、具有进取精神及创业精神，有坚定成功的信心。<br>
                                        02、具有一定经营管理、组织能力，对涂料市场有充分的认识。<br>
                                        03、能够严格遵守专卖店经营章程原则与职业道德。<br>
                                        04、具备良好的商业信誉，无欺诈污点。<br>
                                        05、拥有进行市场推广与品牌建设的必要资金。<br>
                                        06、拥有品牌建设所需的投资理念和风险意识。<br>
                                        07、在行业中拥有一定的客户群体与合作伙伴等人脉资源。<br>
                                        08、能够配合珂立诺艺术涂料的宣传推广，有合理的计划，有较强的执行力。<br>
                                        09、拥有共同投入、共担风险、利益共享的合作意识。<br>
                                        10、能够在经营理念、运作方式、管理制度等方面与公司达成共识并服从公司的管理。&nbsp;<br>
                                        11、有良好的经营管理理念和终端运作能力。<br>
                                        12、必须严格执行按公司标准方案进行专卖店装修，且专卖珂立诺艺术涂料。<br>
                                        &nbsp;<br>
                                        如果您具备了上述条件，并能认可我们的企业文化和市场运作模式，我们随时欢迎您的加盟!<br>
                                        <div class="clearfix"></div>
                                    </nav>
                                </div>


                            </div>
                            <!--content end-->

                        </div>
                        <!--main end-->
                    </div>
                    <!--right end-->
                </div>
                <!--inner end-->
            </div>
            <!--body end-->
            <div class="clearfix"></div>
        </div>
        <zui-footer/>
    </page>
</template>

<script>
  import '../assets/less/home-page.less'
  import Logo from '../components/portal/Logo'
  import Page from '../components/portal/Page'
  import ZuiHeader from '../components/portal/Header'
  import ZuiFooter from '../components/portal/Footer'
  import ZuiButton from '../components/portal/Button'
  import Util from '../Util'
  export default{
    components: {
      Page, Logo, ZuiHeader, ZuiFooter,ZuiButton
    },
    data () {
      return {
        carouselPerPage: (Util.os.android || Util.os.iPhone) ? 1 : 2
      }
    },
    methods: {
    }
  }
</script>
<style scoped lang="less">
    @import '../assets/css/join.css';
    .c1{
        width: 80%;
        margin: 0 auto;
    }
</style>
